import React, { ReactNode } from 'react';

type Props = {
  children: ReactNode
};

const AlertsCompanyArea = function AlertsCompanyArea(props: Props) {
  const { children } = props;
  return (
    <div className="alerts-company-area">{children}</div>
  );
};

export default AlertsCompanyArea;
